import { render, staticRenderFns } from "./DetailProfileGroup.vue?vue&type=template&id=af5d01e0"
import script from "./DetailProfileGroup.vue?vue&type=script&lang=js"
export * from "./DetailProfileGroup.vue?vue&type=script&lang=js"
import style0 from "./DetailProfileGroup.vue?vue&type=style&index=0&id=af5d01e0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports